import {
  getGroupMembers,
  getGroupInfo,
  getGroupOrders,
  setGroupTarget,
  setSellerTarget,
  getGroupClients,
  getGroupCourse,
  updataCourseAssignment,
  getGroupClientCalender,
  getGroupMemberDailyReport,
  getGroupMembersTodolist,
  getGroupSalesData,
  getGroupReturnVisitList,
  getGroupPreOrderList,
  getGroupNewClientsList,
  newGroupDailyReport,
  getGroupPreOrders,
  ReturnVisitPreOrder,
  getGroupSellerWechats,
  updateGroupSellerWechatUser,
  changeOrderUser,
  getGroupRefunds,
  auditGroupRefund
  
} from '@/api/group'

const state = {};

const mutations = {};

const actions = {
  getgroupsellerwechats({commit}) {
    return new Promise((resolve, reject) => {
      getGroupSellerWechats().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updategroupsellerwechatuser({commit}, data) {
    return new Promise((resolve, reject) => {
      updateGroupSellerWechatUser(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  changeorderuser({commit}, data) {
    return new Promise((resolve, reject) => {
      changeOrderUser(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getgrouprefunds({commit}, params) {
    return new Promise((resolve, reject) => {
      getGroupRefunds(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  auditgrouprefund({commit}, data) {
    return new Promise((resolve, reject) => {
      auditGroupRefund(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  getgrouppreorders({commit}, prams) {
    return new Promise((resolve, reject) => {
      getGroupPreOrders(prams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getgroupnewclientslist({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupNewClientsList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newgroupdailyreport({commit}, data) {
    return new Promise((resolve, reject) => {
      newGroupDailyReport(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgrouppreorderlisr({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupPreOrderList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupreturnvisitlist({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupReturnVisitList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupsalesdata({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupSalesData(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupmemberstodolist({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupMembersTodolist(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupmemebersdailyreport({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupMemberDailyReport(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupclientcalender({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupClientCalender(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updatacourseassignment({commit}, data) {
    return new Promise((resolve, reject) => {
      updataCourseAssignment(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getgroupcourse({commit}) {
    return new Promise((resolve, reject) => {
      getGroupCourse().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupclients({commit}, params) {
    return new Promise((resolve, reject) => {
      getGroupClients(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupmembers({commit}) {
    return new Promise((resolve, reject) => {
      getGroupMembers().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setsellertarget({commit}, data) {
    return new Promise((resolve, reject) => {
      setSellerTarget(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setgrouptarget({commit}, data) {
    return new Promise((resolve, reject) => {
      setGroupTarget(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgroupinfo({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupInfo(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getgrouporders({commit}, data) {
    return new Promise((resolve, reject) => {
      getGroupOrders(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  returnvisitpreorder({commit}, params) {
    return new Promise((resolve, reject) => {
      ReturnVisitPreOrder(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
